import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'bootstrap-css-only/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import 'mdbreact/dist/css/mdb.css';
import App from './App';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

